import { useRef } from 'react';
import Icon from '../../icon';

export default function PrintButton() {
  const buttonRef = useRef(null);
  return (
    <button
      onClick={window.print}
      title="Print PDF"
      type="button"
      tabIndex="0"
      ref={buttonRef}
      onMouseLeave={() => buttonRef.current.blur()}
      className="toolbar-icon u-margin-m-right"
      id="print-button"
    >
      <Icon.Printer />
    </button>
  );
}
